import React from "react";
import { MODE_KEYS, MODE_LABELS } from "./cupConstants";

export default function ModeSelectorColumn({ selectedMode, onSelect }) {
  return (
    <div className="flex flex-col gap-2 w-32">
      <h4 className="text-sm font-semibold text-fifth">Mod</h4>
      {MODE_KEYS.map((modeKey) => (
        <button
          key={modeKey}
          type="button"
          onClick={() => onSelect(modeKey)}
          className={`border rounded p-2 text-left ${
            modeKey === selectedMode
              ? "border-main bg-main/10"
              : "border-fifth"
          }`}
        >
          {MODE_LABELS[modeKey]}
        </button>
      ))}
    </div>
  );
}
